<formstep-detail :options="options" :editable="true" :model="tableau"></formstep-detail>